var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotificationsBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9558 20.982H21.9008C22.2102 20.9994 22.5188 20.9372 22.7974 20.8014C23.0759 20.6656 23.315 20.4607 23.4919 20.2062C23.6688 19.9518 23.7775 19.6563 23.8078 19.3479C23.838 19.0395 23.7888 18.7285 23.6648 18.4445C23.2448 17.1752 21.5706 15.6527 21.5706 14.1547C21.5706 10.8297 21.5706 9.95472 19.9326 7.99938C19.4025 7.37 18.7453 6.85989 18.0041 6.50255L17.0906 6.05922C16.9373 5.9667 16.8051 5.84313 16.7024 5.69645C16.5998 5.54978 16.5289 5.38324 16.4944 5.20755C16.4031 4.61536 16.09 4.08006 15.6186 3.71024C15.1471 3.34041 14.5527 3.16373 13.9558 3.21605C13.3697 3.18085 12.7915 3.3654 12.3341 3.73365C11.8768 4.10191 11.5731 4.62741 11.4824 5.20755C11.4413 5.38931 11.3608 5.5598 11.2464 5.70697C11.1321 5.85415 10.9869 5.9744 10.8209 6.05922L9.90744 6.50255C9.16665 6.86003 8.50984 7.37014 7.98011 7.99938C6.34328 9.95472 6.34328 10.8297 6.34328 14.1547C6.34328 15.6527 4.74494 17.0224 4.32494 18.3675C4.07178 19.1807 3.93178 20.982 6.05161 20.982H13.9558Z",
    stroke: "#066D0E",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7618 20.9824C17.7718 21.4851 17.6802 21.9846 17.4924 22.451C17.3046 22.9174 17.0246 23.341 16.6691 23.6965C16.3136 24.052 15.8899 24.3321 15.4235 24.5198C14.9571 24.7076 14.4576 24.7993 13.955 24.7893C13.4522 24.7999 12.9524 24.7087 12.4858 24.5212C12.0192 24.3336 11.5953 24.0536 11.2398 23.6979C10.8842 23.3423 10.6043 22.9183 10.4169 22.4517C10.2295 21.985 10.1385 21.4852 10.1493 20.9824",
    stroke: "#066D0E",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationsBell);
export default __webpack_public_path__ + "static/media/icon-notifications-bell.533b3ce0c40d1beda7662a5585a2bed3.svg";
export { ForwardRef as ReactComponent };